<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Обмен с ГИС ГМП</h3>
            </v-flex>
            <v-flex xs12 sm6>
                <v-btn
                        class="mb-2"
                        @click.native="preparation()"
                >
                    <v-icon class="mr-2">mdi-check</v-icon>
                    Подготовить
                </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12>
                <v-data-table
                        :items="listChargeForPreparation.results"
                        :server-items-length="listChargeForPreparation.last_page"
                        :loading="listLoading.includes('preparationCharges')"
                        hide-default-footer
                        v-model="selected"
                        :headers="headers"
                        no-results-text="Нет отфильтрованных данных"
                        class="elevation-1"
                        item-key="id"
                        show-select
                        :single-select="false"

                >
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination
                            key="pagination"
                            v-model="pagination.page"
                            :length="listChargeForPreparation.last_page"
                    ></v-pagination>
                </div>
            </v-flex>
            <router-view></router-view>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: 'Код',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Сумма',
          align: 'start',
          sortable: false,
          value: 'totalAmount'
        }
      ],
      selected: [],
      search: '',
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    listChargeForPreparation () {
      return this.$store.getters['gis_gmpChargeForPreparation/listChargeForPreparation']
    }
    // selected () {
    //   return this.$store.getters['gis_gmpChargeForPreparation/selected']
    // }
  },
  watch: {
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },
  methods: {
    initialize () {
      this.$store.dispatch('gis_gmpChargeForPreparation/fetchListChargeForPreparation', {
        pageId: this.pagination.page
      })
    },
    getChargeStatus (statusId) {
      return this.$store.getters['gis_gmpCharge/getChargeStatus'](statusId)
    },
    getChargeCondition (conditionId) {
      return this.$store.getters['gis_gmpCharge/getChargeCondition'](conditionId)
    },
    preparation () {
      let ides = this.selected.map(function (item) {
        return item.id
      })
      this.$store.dispatch('gis_gmpChargeForPreparation/preparationCharges', {
        pageId: this.pagination.page,
        ides: ides
      })
      this.pagination.page = 1
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>

<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
